import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface AddPartnerToMembershipBody {
    partnerEmail: string;
    partnerFirstName?: string;
    partnerLastName?: string;
}

export const useAddPartnerToMembership = requestBuilder.mutation<
    GeneralResponse,
    AddPartnerToMembershipBody,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/users/${id}/add-partner`,
    method: 'POST',
});
